import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';

import { SkeletonTable, SkeletonPageFooter } from 'ui/components/skeleton';
import useTable from 'ui/components/table';

import { Table } from 'services/action';

import tableConfig from './table.config';
import Action from './action';

const initialState = {
  privilege: null,
  isShow: false,
};

const SettingHubScreen = () => {
  const Dispatch = useDispatch();
  const HubTable = useTable('hub', tableConfig);

  const Session = useSelector((state) => state.Auth?.session);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Table.Request']
  );
  const StateTable = useSelector((state) => state?.Table?.data['hub']);

  const [{ privilege }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.platform.location.hub',
    });

    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, [Session]);

  return (
    <div className="sub-page">
      <div className="sub-page-navigation">
        <HubTable.Tools downloadable>
          {(!Session?.privileges || privilege?.action === 'manage') && (
            <Action
              onClose={() => Dispatch(Table.$reload('hub', StateTable))}
            />
          )}
        </HubTable.Tools>
      </div>
      <div className="sub-page-body">
        {StateLoading ? (
          <SkeletonTable headerCount={6} bodyCount={10} />
        ) : (
          <HubTable.Render />
        )}
      </div>

      <div className="sub-page-footer">
        {StateLoading ? <SkeletonPageFooter /> : <HubTable.Pagination />}
      </div>
    </div>
  );
};

export default SettingHubScreen;
